export default __webpack_public_path__ + "static/media/great.a7f4edec.png";